import React from 'react';
import { PostType } from '../types';
import CustomTooltip from '../../../common/CustomTooltip/CustomTooltip';
import styles from '../../../../styles/usageRights.module.css';

interface CaptionContainerProps {
  caption: string;
  type: PostType;
}

function CaptionContainer({ caption, type }: CaptionContainerProps) {
  return (
    <div className={styles.captionContainer}>
      {caption?.length ? (
        caption
      ) : (
        <CustomTooltip title={type === 'story' ? 'No captions on stories' : 'No caption'}>
          <div className={styles.noCaptionContainer}>...</div>
        </CustomTooltip>
      )}
    </div>
  );
}

export default CaptionContainer;
